import React, { useEffect } from 'react';
import { request } from './utils'
import { Routes } from './config'

const App = () => {

  return (
    <div className="App">
     <Routes />
    </div>
  );
}

export default App;
